import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Logo } from "./sidebar/Logo";
import { Navigation } from "./sidebar/Navigation";
import { UserProfile } from "./sidebar/UserProfile";
import { Button } from "./ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

interface SidebarProps {
  collapsed: boolean;
  onToggle: (collapsed: boolean) => void;
}

export const Sidebar = ({ collapsed, onToggle }: SidebarProps) => {
  const isMobile = useIsMobile();

  // Save the collapsed state to localStorage
  const toggleSidebar = () => {
    const newState = !collapsed;
    onToggle(newState);
    localStorage.setItem("sidebar-collapsed", String(newState));
  };

  if (isMobile) {
    return null;
  }

  return (
    <div 
      className={cn(
        "bg-white dark:bg-gray-950 border-r border-border/50 text-foreground h-screen flex flex-col relative transition-all duration-300 ease-in-out min-h-0",
        collapsed ? "w-20" : "w-64"
      )}
    >
      <div className="relative flex-shrink-0">
        <Logo collapsed={collapsed} />
        <Button 
          onClick={toggleSidebar}
          variant="ghost"
          size="icon"
          className={cn(
            "absolute text-foreground h-8 w-8 flex items-center justify-center hover:bg-muted transition-colors rounded-sm",
            collapsed ? "right-3 top-6" : "right-3 top-6"
          )}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
        </Button>
      </div>
      <div className="flex-1 min-h-0 flex flex-col">
        <Navigation collapsed={collapsed} />
        <UserProfile collapsed={collapsed} />
      </div>
    </div>
  );
};
